<template>
    <section class="empty">
        <div class="empty__body">
            <img :src="image" :alt="title" class="empty__image">
            <header class="empty__header">
                <h4 class="empty__title">{{ title }}</h4>
                <p v-if="subtitle" class="empty__subtitle">{{ subtitle }}</p>
            </header>
            <slot />
        </div>
    </section>
</template>

<script>
export default {
    name: 'Empty',

    props: {
        type: {
            required: true,
            type: String,
            validator (value) {
                return ['photos', 'cuppa', 'papers', 'clock', 'tasks'].includes(value)
            }
        },

        title: {
            required: true,
            type: String
        },

        subtitle: {
            required: false,
            type: String
        }
    },

    computed: {
        image () {
            return '/images/empties/' + this.type + '.svg'
        }
    }
}
</script>
